module.exports = __webpack_public_path__ + "img/iosteacher.be8d8b33.png";